import React from 'react';

// Sample categories and popular posts data
const categories = ["E-commerce Trends", "Marketing", "Technology"];
const popularPosts = [
  { title: "5 Ways to Reduce Cart Abandonment", date: "Mar 1, 2024" },
];

export function Sidebar({ className }) {
  return (
    <aside className={className}>
      {/* Categories Section */}
      <div className="mb-6 bg-white shadow-lg rounded-lg p-4">
        <h3 className="text-xl font-semibold mb-4">Categories</h3>
        <div className="flex flex-wrap gap-2">
          {categories.map((category, index) => (
            <span
              key={index}
              className="bg-gray-200 text-gray-700 px-3 py-1 text-sm font-semibold rounded-md"
            >
              {category}
            </span>
          ))}
        </div>
      </div>

      {/* Popular Posts Section */}
      <div className="mb-6 bg-white shadow-lg rounded-lg p-4">
        <h3 className="text-xl font-semibold mb-4">Popular Posts</h3>
        <ul className="space-y-4">
          {popularPosts.map((post, index) => (
            <li key={index}>
              <h4 className="font-medium hover:text-blue-500 cursor-pointer">
                {post.title}
              </h4>
              <p className="text-sm text-gray-500">{post.date}</p>
            </li>
          ))}
        </ul>
      </div>

      {/* Newsletter Section */}
      <div className="bg-white shadow-lg rounded-lg p-4">
        <h3 className="text-xl font-semibold mb-4">Newsletter</h3>
        <p className="mb-4 text-sm text-gray-600">
          Stay updated with our latest posts.
        </p>
        <form className="space-y-2">
          <input
            type="email"
            placeholder="Your email address"
            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            className="w-full py-2 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600"
          >
            Subscribe
          </button>
        </form>
      </div>
    </aside>
  );
}
